export default __webpack_public_path__ + "static/media/AIModelView.0d6b1968.svg";